import { styled } from '@mui/material';
import { Grid } from '@mui/system';

const PREFIX = 'ValuationOpinionSummaryData';

export const classes = {
  root: `${PREFIX}-root`,
  boxValOpinion: `${PREFIX}-boxValOpinion`,
  boxValMethods: `${PREFIX}-boxValMethods`,
};

export const StyledGrid = styled(Grid)(() => ({
  [`& .${classes.root}`]: {
    boxShadow: 'none',
  },

  // Tight under the banner — the note belongs to it, not to the charts below.
  [`& .${classes.boxValOpinion}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
  },

  [`& .${classes.boxValMethods}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 8,
  },
}));
